<template>
  <div id="AdminalbumList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">相簿列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">相簿</li>
              <li class="breadcrumb-item active">相簿列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-album" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-10">
            <el-select
              class="col-lg-1"
              v-model="filterParams.albumType"
              placeholder="相簿類型"
              clearable=""
            >
              <el-option
                :value="type.id"
                :label="type.sgL_NewName"
                v-for="(type) in albumTypeList"
                :key="type.id"
              ></el-option>
            </el-select>
            <el-input
              class="col-lg-2"
              v-model="filterParams.title"
              placeholder="相簿名稱"
            ></el-input>
            <el-input
              class="col-lg-2"
              v-model="filterParams.keyword"
              placeholder="關鍵字"
            ></el-input>
            <el-input
              class="col-lg-1"
              v-model="filterParams.author"
              placeholder="作者"
            ></el-input>
            <el-select class="col-lg-1" v-model="filterParams.chargeStatus">
              <el-option label="收費" :value="true"></el-option>
              <el-option label="免費" :value="false"></el-option>
            </el-select>
            <el-date-picker
              class="col-lg-2"
              v-model="filterParams.AddTimerDate"
              placeholder="日期"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <!-- <el-select v-model="filterParams.publicshare">
              <el-option label="公開" value="1"></el-option>
              <el-option label="不公開" value="2"></el-option>
              <el-option label="私人" value="3"></el-option>
            </el-select> -->
          <!-- <div class="b-filter">
              <a href="" class="current">全部</a><a href="">重機</a
              ><a href="">路跑</a><a href="">單車</a><a href="">鐵人</a
              ><a href="">球類運動</a><a href="">水上運動</a
              ><a href="">綜合運動</a><a href="">風景生活</a
              ><a href="">非公開相簿</a><a href="">私人相簿</a>
            </div> -->
        </div>
        <div class="col-sm-2">
          <!-- <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              data-toggle="modal"
              data-target="#modal-album--filter"
            >
              <i class="nav-icon fas fa-filter fa-sm mr-1"></i> 篩選條件
            </button> -->
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <el-table
                :data="getAdminAlbumList"
                row-key="id"
                border
                v-loading="isload"
                @cell-click="cellclick"
                @sort-change="sortChange"
              >
                <el-table-column label="相簿標題" width="380">
                  <template slot-scope="scope">
                    <router-link
                      target="_blank"
                      v-bind:to="{
                        name: 'albumviewPhotostream',
                        query: {
                          id: scope.row.id,
                        },
                      }"
                    >
                      <div class="b-album-block mr-2">
                        <div class="b-album-thumbnail">
                          <div class="b-album-responsive">
                            <div class="b-album-sizer">
                              <div
                                class="b-album-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${scope.row.photoImage}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="b-title">
                        {{ scope.row.sgL_PG_CName }}
                      </span>
                      <span class="b-tag">
                        <a
                          href="javascript:void(0)"
                          v-for="word in scope.row.sgL_KeywordF"
                          :key="word"
                        >
                          {{ word }}
                        </a>
                      </span>
                      <!-- s -->
                    </router-link>
                  </template>
                </el-table-column>

                <el-table-column label="上傳者" prop="sgL_Mem_DisplayName">
                  <template slot-scope="scope">
                    <el-link type="primary">
                      {{ scope.row.sgL_Mem_DisplayName }}</el-link
                    >
                  </template>
                </el-table-column>

                <el-table-column label="類型">
                  <template slot-scope="scope">
                    <a href=""> {{ scope.row.sgL_PG_CMasterSortName }} </a>
                  </template></el-table-column
                >

                <el-table-column
                  label="上傳日期/狀態"
                  width="150"
                  sortable="custom"
                  prop="sgL_CreateTime"
                >
                  <template slot-scope="scope">
                    {{ scope.row.sgL_PG_CAddTimerF }}
                    <span
                      class="b-subtext b-public"
                      v-if="scope.row.sgL_PG_CPublicshare"
                    >
                      公開
                    </span>
                    <span class="b-subtext b-unlisted" v-else> 不公開 </span>
                    <!-- <span class="b-subtext b-charge"> 收費相簿 </span> -->
                  </template></el-table-column
                >
                <el-table-column
                  prop="sgL_PG_CPhotoQuantityF"
                  label="相片數"
                ></el-table-column>

                <el-table-column
                  prop="sgL_PG_CTotalDiskSize"
                  label="容量"
                  sortable="custom"
                >
                  <template slot-scope="scope">
                    {{ scope.row.sgL_PG_CTotalDiskSizeF }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="sgL_PG_CViewQuantity"
                  label="瀏覽量"
                  sortable="custom"
                ></el-table-column>

                <el-table-column
                  prop="sgL_PG_CTotalLike"
                  label="讚好"
                ></el-table-column>

                <el-table-column
                  prop="sgL_PG_CTotalMessage"
                  label="留言"
                ></el-table-column>

                <el-table-column
                  prop="sgL_PG_CTotalFavorite"
                  label="收藏"
                ></el-table-column>

                <el-table-column
                  prop="sgL_PG_CTotalDownload"
                  label="下載"
                ></el-table-column>

                <el-table-column
                  prop="sgL_PG_CTotalShare"
                  label="分享"
                ></el-table-column>
                <el-table-column label="操作" width="260">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="retry(scope.row.id)"
                      >重試裁剪</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="editAlbum(scope.row.id)"
                      >編輯</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="
                        open(
                          $event,
                          scope.row.id,
                          `您確定將相簿[${scope.row.sgL_PG_CName}]刪除？`,
                          '刪除相簿'
                        )
                      "
                      >刪除</el-button
                    ></template
                  >
                </el-table-column>
              </el-table>
            </div>
            <!-- /.card-body -->
            <div class="row">
              <div class="col-lg-4 offset-lg-4">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- /.col-12 -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.Container Fluid -->
    <!-- Modal: 篩選條件 -->
    <div class="modal fade" id="modal-album--filter">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">篩選條件</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>相簿名稱</label>
              <div class="input-group mb-3">
                <input class="form-control" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>上傳者</label>
              <div class="input-group mb-3">
                <input class="form-control" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>類型（不勾選為全部類型）</label>
              <div class="form-group mb-3">
                <div class="row mb-2">
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-motorbike" />
                      <label for="category-motorbike"> 重機 </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-road-run" />
                      <label for="category-road-run"> 路跑 </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-bicycle" />
                      <label for="category-bicycle"> 單車 </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-triathlon" />
                      <label for="category-triathlon"> 鐵人 </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-ball-game" />
                      <label for="category-ball-game"> 球類運動 </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-water-sport" />
                      <label for="category-water-sport"> 水上運動 </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input
                        type="checkbox"
                        id="b-category-comprehensive-sport"
                      />
                      <label for="category-comprehensive-sport">
                        綜合運動
                      </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="icheck-primary d-inline">
                      <input type="checkbox" id="b-category-daily" />
                      <label for="category-daily"> 風景生活 </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>公開狀態</label>
              <div class="form-group">
                <select class="form-control custom-select select2-no-search">
                  <option>全部</option>
                  <option>公開</option>
                  <option>不公開</option>
                  <option>私人</option>
                </select>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>收費狀態</label>
              <div class="form-group">
                <select class="form-control custom-select select2-no-search">
                  <option>全部</option>
                  <option>收費相簿</option>
                  <option>免費相簿</option>
                </select>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>上傳日期介乎</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right date-range-picker"
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>包含關鍵字</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right date-range-picker"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-toggle="modal"
              data-dismiss="modal"
            >
              篩選
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal: 篩選條件 -->
    <!-- Modal: 設為編輯推薦 -->
    <div class="modal fade" id="modal-featured--add">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>將相簿<b>「相簿名稱」</b>設為編輯推薦？</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary featured--add---success"
              data-dismiss="modal"
            >
              設為編輯推薦
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal: 設為編輯推薦 -->
    <!-- Modal: 從編輯推薦中移除 -->
    <div class="modal fade" id="modal-featured--remove">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>將相簿<b>「相簿名稱」</b>從編輯推薦中移除？</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary featured--remove---success"
              data-dismiss="modal"
            >
              從編輯推薦中移除
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal: 從編輯推薦中移除 -->
    <!-- Modal: 合集管理 -->
    <div class="modal fade" id="modal-collection--set">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">合集管理</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <select class="duallistbox" multiple="multiple">
                <option>(顯示最新50個合集)</option>
                <option>2020 台北渣打馬拉松</option>
                <option>REASON TO RUN 2020</option>
                <option>06/20 北宜追焦</option>
                <option>06/19 138縣道追焦</option>
                <option>香港泰拳錦標賽</option>
              </select>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary featured--set---success"
              data-dismiss="modal"
            >
              保存
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal: 合集管理 -->
    <!-- Modal: 刪除相簿 -->
    <div class="modal fade" id="modal-album--remove">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              確認刪除相簿<b>「相簿名稱」</b>？<br />
              <b>相簿一旦刪除，將無法復原。</b>
            </p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-b-danger"
              data-toggle="modal"
              data-dismiss="modal"
              data-target="#modal-album--remove---warning"
            >
              是，刪除
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal: 刪除相簿 -->
    <!-- Modal: 確認刪除核實 -->
    <div class="modal fade" id="modal-album--remove---warning">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p class="mb-3">
              <b>*** 此乃重要資料，請勿隨意修改 ***</b><br />
              如欲確認刪除，請輸入閣下 (登入帳戶名稱) 之密碼進行安全確認：
            </p>
            <div class="row align-center">
              <div class="col-2">
                <label class="mb-0">密碼</label>
              </div>
              <div class="col-6">
                <div class="input-group">
                  <input type="password" class="form-control" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-danger album--remove---success"
              data-dismiss="modal"
            >
              刪除相簿
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal: 確認刪除核實 -->
  </div>
  <!-- /.Content -->
</template>
<script>
import pagination from "../common/Page";
export default {
  data() {
    return {
      sortASC: "ascending",
      sorting: "sgL_CreateTime",
      adminAlbumList: null,
      albumTypeList: null,
      filterParams: {
        albumType: null,
        title: null,
        keyword: null,
        chargeStatus: null,
        author: null,
        AddTimerDate: [],
        keyword: null,
      },
      isload: true,
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageshow: true,
      },
    };
  },
  watch: {
    "filterParams.albumType": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
          this.GetAdminPhotoGalleryList();
        }
      },
    },
    "filterParams.chargeStatus": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
          this.GetAdminPhotoGalleryList();
        }
      },
    },
    "filterParams.title": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
          this.GetAdminPhotoGalleryList();
        }
      },
    },
    "filterParams.keyword": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
          this.GetAdminPhotoGalleryList();
        }
      },
    },
    "filterParams.author": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
          this.GetAdminPhotoGalleryList();
        }
      },
    },
    "filterParams.AddTimerDate": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
          this.GetAdminPhotoGalleryList();
        }
      },
    },
  },
  components: {
    pagination,
  },
  created() {
    this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
      this.albumTypeList = res; //相簿類型
    });
    this.GetAdminPhotoGalleryList();
  },
  methods: {
    retry(id) {
      this.$api.albumApi.PushRetryDto({ coid: id }).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          this.$message({
            type: "error",
            message: this.$t('message.operationfailure')+'' + res.data.error,
          });
        }
      });
    },
    sortChange(sort) {
      this.sortASC = sort.order;
      this.sorting = sort.prop;
      this.GetAdminPhotoGalleryList();
    },
    GetAdminPhotoGalleryList() {
      let params = {
        SGL_PG_CMasterSort: this.filterParams.albumType,
        IsCharge: this.filterParams.chargeStatus,
        SGL_PG_CName: this.filterParams.title,
        SGL_DisplayName: this.filterParams.author,
        SGL_PG_LPhotoKey: this.filterParams.keyword,
        SGL_AddTimerDate: this.filterParams.AddTimerDate,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        sorting: this.sorting,
        sortASC: this.sortASC,
      };
      this.$api.albumApi.GetAdminPhotoGalleryList(params).then((res) => {
        if (res.data.success) {
          this.adminAlbumList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
          this.isload = false;
        }
      });
    },
    editAlbum(id) {
      this.$router.push({ name: "uploadImage", query: { id: id, tid: 3 } });
    },
    //打开模态框
    open(e, Id, operator, title, method) {
      this.$confirm(operator, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // if (method == "removeFeatured" || method == "addFeatured") {
          //   await this.Choice(Id, method);
          // } else {
          //   await this.DeleteTv(Id);
          // }
          await this.DeleteAlbum(Id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作取消",
          });
        });
    },
    DeleteAlbum(id) {
      let params = {
        Id: id,
      };
      this.$api.albumApi.delAlbum(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          this.$message({
            type: "error",
            message: this.$t('message.operationfailure'),
          });
        }
        this.GetAdminPhotoGalleryList();
      });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetAdminPhotoGalleryList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetAdminPhotoGalleryList();
    },
    cellclick(row, column, $event, cell) {
      if (column.property == "sgL_Mem_DisplayName") {
        this.filterParams.author = row.sgL_Mem_DisplayName;
      }
    },
  },
  computed: {
    getAdminAlbumList() {
      return this.adminAlbumList;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminAlbum/AdminalbumList.vue